import { render, staticRenderFns } from "./pparentchildpk.vue?vue&type=template&id=97cbb3ba&scoped=true&"
import script from "./pparentchildpk.vue?vue&type=script&lang=js&"
export * from "./pparentchildpk.vue?vue&type=script&lang=js&"
import style0 from "./pparentchildpk.vue?vue&type=style&index=0&id=97cbb3ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97cbb3ba",
  null
  
)

export default component.exports